export const LANGUAGE_LIST = {
  CHINESE: {
    encoding: "ZH",
    value: "CHINESE",
    label: "tinymce_plugin_text_to_speech_language_filter_option_chinese",
  },
  MALAY: {
    encoding: "MS",
    value: "MALAY",
    label: "tinymce_plugin_text_to_speech_language_filter_option_malay",
  },
  TAMIL: {
    encoding: "TA",
    value: "TAMIL",
    label: "tinymce_plugin_text_to_speech_language_filter_option_tamil",
  },
  ENGLISH: {
    encoding: "EN",
    value: "ENGLISH",
    label: "tinymce_plugin_text_to_speech_language_filter_option_english",
  },
};

export const ZH_TTS_CHARACTER_LIMIT = 2000;
export const MS_TA_TTS_CHARACTER_LIMIT = 1000;
